import React, { FC, useCallback, useEffect, useState } from 'react';

import { EmailRule } from 'devextreme-react/form';
import Validator, { RequiredRule } from 'devextreme-react/validator';

import { AppCol, AppFieldBox, AppGroup, AppRow } from 'components/appComponents';
import { CheckBox, DateBox, SelectBox, TextArea, TextBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { EmployeeItem } from 'bus/employee/types';
import { FactoryDetail } from 'bus/factory/types';
import { PostItem } from 'bus/post/types';

import { male } from 'types/books';

type MainInfoProps = {
  form: EmployeeItem;
  changeForm: (form: EmployeeItem) => void;
  storePost: PostItem[];
  storeFactory: FactoryDetail[];
};

const MainInfo: FC<MainInfoProps> = (props) => {
  const [types, setTypes] = useState<any[]>([]);

  const getStatus = useCallback(async () => {
    const result = await $createDataSource('/v1/Employee/statuses', 'id').load();
    setTypes(result);
  }, []);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  return (
    <div>
      <AppRow>
        <AppCol col={8}>
          <AppGroup title="">
            <AppCol col={4}>
              <AppFieldBox label="Фамилия" labelTop>
                <TextBox
                  stylingMode="underlined"
                  placeholder="Введите фамилию"
                  mode="text"
                  value={props.form.surname}
                  onValueChange={(e) => {
                    props.changeForm({ ...props.form, surname: e });
                  }}
                >
                  <Validator>
                    <RequiredRule message="Заполните поле Фамилия" />
                  </Validator>
                </TextBox>
              </AppFieldBox>
            </AppCol>
            <AppCol col={4}>
              <AppFieldBox label="Имя" labelTop>
                <TextBox
                  stylingMode="underlined"
                  placeholder="Введите Имя"
                  mode="text"
                  value={props.form.name}
                  onValueChange={(e) => {
                    props.changeForm({ ...props.form, name: e });
                  }}
                >
                  <Validator>
                    <RequiredRule message="Заполните поле Имя" />
                  </Validator>
                </TextBox>
              </AppFieldBox>
            </AppCol>
            <AppCol col={4}>
              <AppFieldBox label="Отчество" labelTop>
                <TextBox
                  stylingMode="underlined"
                  placeholder="Введите Отчество"
                  mode="text"
                  value={props.form.middleName}
                  onValueChange={(e) => {
                    props.changeForm({ ...props.form, middleName: e });
                  }}
                />
              </AppFieldBox>
            </AppCol>

            <div className="mt-2">
              <AppCol col={4}>
                <AppFieldBox label="Пол" labelTop>
                  <SelectBox
                    stylingMode="underlined"
                    placeholder="Выберите пол"
                    displayExpr="name"
                    mode="text"
                    value={props.form.sex}
                    onValueChange={(e) => {
                      props.changeForm({ ...props.form, sex: e });
                    }}
                    valueExpr="id"
                    dataSource={male}
                  >
                    <Validator>
                      <RequiredRule message="Заполните поле пол" />
                    </Validator>
                  </SelectBox>
                </AppFieldBox>
              </AppCol>
              <AppCol col={4}>
                <AppFieldBox label="Должность" labelTop>
                  <SelectBox
                    stylingMode="underlined"
                    placeholder="Выберите должность"
                    mode="text"
                    searchExpr={['name']}
                    valueExpr="id"
                    value={props.form.postId}
                    onValueChange={(e) => {
                      props.changeForm({ ...props.form, postId: e, factoryId: null });
                    }}
                    displayExpr="name"
                    items={props.storePost}
                  >
                    <Validator>
                      <RequiredRule message="Заполните поле должность" />
                    </Validator>
                  </SelectBox>
                </AppFieldBox>
              </AppCol>
              <AppCol col={4}>
                <AppFieldBox label="Площадка" labelTop>
                  <SelectBox
                    stylingMode="underlined"
                    placeholder="Выберите площадку"
                    mode="text"
                    searchExpr={['name']}
                    valueExpr="id"
                    value={props.form.factoryId}
                    onValueChange={(e) => {
                      props.changeForm({ ...props.form, factoryId: e });
                    }}
                    displayExpr="name"
                    items={props.storeFactory}
                  />
                </AppFieldBox>
              </AppCol>
            </div>
          </AppGroup>

          <AppGroup>
            <AppCol col={4}>
              <AppFieldBox label="" labelTop>
                <CheckBox
                  value={props.form.isResident}
                  text="Резидент"
                  onValueChange={(e) => props.changeForm({ ...props.form, isResident: !!e })}
                />
              </AppFieldBox>
            </AppCol>
            <AppCol col={4}>
              <AppFieldBox label="" labelTop>
                <CheckBox
                  value={props.form.isOfficiallyEmployed}
                  text="Оф. трудоустроен"
                  onValueChange={(e) => props.changeForm({ ...props.form, isOfficiallyEmployed: !!e })}
                />
              </AppFieldBox>
            </AppCol>
          </AppGroup>

          <AppGroup>
            <AppCol col={12}>
              <AppFieldBox label="Реквизиты" labelTop>
                <TextBox
                  stylingMode="underlined"
                  placeholder="Реквизиты"
                  mode="text"
                  value={props.form.requisites || ''}
                  onValueChange={(e) => {
                    props.changeForm({ ...props.form, requisites: e });
                  }}
                />
              </AppFieldBox>
            </AppCol>
            <AppCol col={12}>
              <AppFieldBox label="Комментарий" labelTop>
                <TextArea
                  stylingMode="underlined"
                  placeholder="Введите комментарий"
                  mode="text"
                  value={props.form.comment}
                  onValueChange={(e) => props.changeForm({ ...props.form, comment: e })}
                ></TextArea>
              </AppFieldBox>
            </AppCol>
          </AppGroup>
        </AppCol>

        <AppCol col={4}>
          <AppGroup title="Контакты">
            <div className="mt-2">
              <AppCol col={12}>
                <AppFieldBox label="Телефон" labelTop>
                  <TextBox
                    stylingMode="underlined"
                    placeholder="Введите Телефон"
                    mode="text"
                    value={props.form.phone}
                    onValueChange={(e) => {
                      props.changeForm({ ...props.form, phone: e });
                    }}
                    mask="+7 (000) 000-00-00"
                  >
                    <Validator>
                      <RequiredRule message="Заполните поле Телефон" />
                    </Validator>
                  </TextBox>
                </AppFieldBox>
              </AppCol>
              <AppCol col={12}>
                <AppFieldBox label="Email" labelTop>
                  <TextBox
                    stylingMode="underlined"
                    placeholder="Введите Email"
                    mode="text"
                    value={props.form.email}
                    onValueChange={(e) => {
                      props.changeForm({ ...props.form, email: e });
                    }}
                  >
                    <Validator>
                      <EmailRule message="Email некорректный"></EmailRule>
                    </Validator>
                  </TextBox>
                </AppFieldBox>
              </AppCol>

              <AppCol col={12}>
                <AppFieldBox label="Статус" labelTop>
                  <SelectBox
                    stylingMode="underlined"
                    placeholder="Выберите статус"
                    mode="text"
                    valueExpr="id"
                    value={props.form.status}
                    onValueChange={(e) => {
                      //@ts-ignore
                      props.changeForm({ ...props.form, status: e, dateOfDismissal: null });
                    }}
                    displayExpr="name"
                    items={types}
                  >
                    <Validator>
                      <RequiredRule message="Заполните поле статус" />
                    </Validator>
                  </SelectBox>
                </AppFieldBox>
              </AppCol>
              {props.form.status === 1 && (
                <AppCol col={12}>
                  <AppFieldBox label="Дата увольнения" labelTop>
                    <DateBox
                      stylingMode="underlined"
                      type="date"
                      onValueChange={(e) => props.changeForm({ ...props.form, dateOfDismissal: e as string })}
                      useMaskBehavior
                      dateSerializationFormat="yyyy-MM-dd"
                      value={props.form.dateOfDismissal}
                    >
                      <Validator>
                        <RequiredRule message="Заполните поле Дата" />
                      </Validator>
                    </DateBox>
                  </AppFieldBox>
                </AppCol>
              )}
            </div>
          </AppGroup>
        </AppCol>
      </AppRow>
    </div>
  );
};
export default MainInfo;
